import { gql } from "@apollo/client";

export const signupMutation = gql`
  mutation RegisterUser($data: RegisterInput!) {
    registerUser(data: $data) {
      success
      message
    }
  }
`;

export const loginMutation = gql`
  mutation Login($data: LoginInput!) {
    login(data: $data) {
      access_token
      refresh_token
      expires_in
      authId
    }
  }
`;
